import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { groupBy } from 'lodash';
import { IMessageGroupMGInputModel, IMessageGroupOutputModel } from 'src/app/ViewModel/CommunicationModel';
@Component({
  selector: 'app-common-cart',
  templateUrl: './common-cart.component.html',
  styleUrls: ['./common-cart.component.css']
})
export class CommonCartComponent implements OnInit {
  selectedRootIndex: number = 0;
  employeeTab: boolean = true;
  distTab: boolean = false;
  addTabVal: number = 0;
  receiverType: number = 1;
  selectedList: any[] = [];
  savedMessageGroup!: IMessageGroupMGInputModel;
  public docList!: any[];
  public postedGroupList: any[] = [];
  projectBusinessGroupId: number = 0;
  /** Project business group list */
  projectBusinessGroupList: BusinessGroupModel[] = [];
  memberList: ProjectMemberModel[] = [];
  projectSelectedMembers: ProjectMemberModel[] = [];
  /** Cart filtered data source. removed duplication with selected data */
  cartDataSource: ProjectMemberModel[] = [];
  /** Cart Right side (seleceted data) */
  cartSelectedList: any[] = [];
  cartRequest = {};
  cartSelectedListCopy!: any[];
  selectedResult: string = '';
  public messageGroupList: IMessageGroupOutputModel[] = [];
  constructor(
    public dialogRef: MatDialogRef<CommonCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public projectMemberLinkService: ProjectMemberLinkService,
    public commonService: CommonService,
    public notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.receiverType = this.data.receiverType;
    this.selectedList = this.data.alreadySelectedList;
    this.projectBusinessGroupId = +this.commonService.getLoggedInUserGroupId();
    this.getProjectBusinessGroup();
    if (this.selectedList != undefined) {
      let res = this.selectedList.filter(y => y.isGroup == false).map(x => x.title);
      this.selectedResult = res.map(x => x).toString();
    }
  }

  public tabClick(event: any) {

    if (event.tab.textLabel === 'Distribution List') {
      this.employeeTab = false;
      this.addTabVal = 0;
      this.distTab = true;
    }
    else {
      this.distTab = false;
      this.addTabVal = 0;
      this.employeeTab = true;
    }
  }

  AddMGList() {
    this.distTab = true;
    this.addTabVal = 1;
    this.employeeTab = false;
  }
  async getProjectBusinessGroup() {
    let response = await this.projectMemberLinkService.getProjectBusinessGroup(this.commonService.getProjectId()).toPromise();
    this.projectBusinessGroupList = response.filter((each: any) => each.is_Active);
  }

  async changeProjectBusinessGroup(event: any) {
    if (event.value != '-2') {
      this.projectBusinessGroupId = event.value;
      this.memberList = await this.projectMemberLinkService.getSelectedMemberList(this.commonService.getProjectId(), this.projectBusinessGroupId).toPromise();
      if (this.data.alreadySelectedList != undefined) {
        let alreadyselectedMembers = this.data.alreadySelectedList.filter((x: { isGroup: boolean; }) => x.isGroup == false);
        this.projectSelectedMembers = alreadyselectedMembers.map((x: { value: number; }) => {
          return this.memberList.find(member => member.memberId == x.value);
        });
        this.memberList = this.changeKeyFormat(this.memberList, alreadyselectedMembers);
      }
      else {
        this.projectSelectedMembers = [];
      }
    } else {
      this.projectBusinessGroupId = 0;
      this.projectSelectedMembers = [];
    }
    this.setCartValues();
  }

  closeDialog(data: any) {
    if (data && data.length > 0) {
      this.dialogRef.close({ selectedText: this.selectedResult, data: data });
    }
    else {
      this.dialogRef.close(data);
    }
  }

  changeKeyFormat(inputArr: any, alreadySelectedMembers: []) {
    let grpdSelectedMembers = groupBy(alreadySelectedMembers, 'value');
    let outputArr: any = [];
    inputArr.forEach((eachObj: any) => {
      if (!(grpdSelectedMembers && grpdSelectedMembers[eachObj['memberId']] && grpdSelectedMembers[eachObj['memberId']].length)) {
        outputArr.push(eachObj);
      }
    });
    return outputArr;
  }

  setCartValues() {
    this.cartDataSource = this.removeDuplicates(this.memberList, this.projectSelectedMembers, 'memberId');
    this.cartSelectedList = [];
    this.cartSelectedListCopy = [];
    this.projectSelectedMembers.forEach(eachMember => {
      let cartValue: any = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
      this.cartSelectedList.push(cartValue);
      this.cartSelectedListCopy.push(cartValue);
    });
    this.setCartParams();
  }

  removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
    let filteredArray: any = [],
      grpdSelecetedArray = groupBy(selectedArray, key);

    dataSource.forEach((eachData: any) => {
      if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
        filteredArray.push(eachData);
      }
    });
    return filteredArray;
  }

  getAsCartSelectedValue(value: string | number, text: string) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text
    };
    return output;
  }

  setCartParams() {
    this.cartRequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartSelectedList,
      },
      'settings': {
        'mode': 'popup',
        'textField': 'memberName',
        'valueField': 'memberId',
        'cartLabel': 'Members',
      },
      'dataSource': this.cartDataSource,
    }
  }

  getSelectedCartItems(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
    let data: any = this.data.alreadySelectedList;
    event.map(x => {
      let index = this.data.alreadySelectedList.findIndex((y: any) => y.value == x.value);
      if (index == -1) {
        data.push({
          value: x.value,
          title: x.additionalValues.additionalValues["memberName"],
          isActive: true,
          isGroup: false,
          groupId: 0,
          groupName: ''
        });
      }
    });
    data.forEach((value: { value: string | number; }, index: string | number) => {
      let id = event.findIndex(y => y.value == value.value);
      if (id == -1) {
        data[index].isActive = false;
      }
    });
    let res = data.filter((x: { isActive: boolean; }) => x.isActive == true).map((x: { title: any; }) => x.title);
    this.selectedResult = res.map((x: any) => x).toString();
    this.closeDialog(data);
  }

  postMessageGroup(event: any[]) {
    this.postedGroupList = [];
    event.map(e => {
      let temp = e.memberList.map((x: { value: any; text: any; }) => {
        this.postedGroupList.push({
          value: x.value,
          title: x.text,
          isActive: true,
          isGroup: true,
          groupId: e.value,
          groupName: e.text
        });
      });
    });
    let res = event.map(x => x.text);
    this.selectedResult = this.selectedResult + res.map(x => x).toString();
    this.closeDialog(this.postedGroupList);
  }
}
